import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { GmsLoginComponent } from '../gms-login/gms-login.component';
import { GmsNavMenuComponent } from '../gms-nav-menu/gms-nav-menu.component';
import { GmsWelcomeComponent } from '../gms-welcome/gms-welcome.component';
import { PageNotFoundComponent } from '../page-not-found/page-not-found.component';
import { GmsAuthGuard } from '../core/services/gms-auth.guard';
import { ChangepasswordComponent } from '../changepassword/changepassword.component';
//import { GamesManagementMenuNavComponent } from '../modules/games-management/games-management-menu-nav/games-management-menu-nav.component';

const gmsRoutes: Routes = [{ path: 'login', component: GmsLoginComponent },
{
  path: 'gmsnavmenu', component: GmsNavMenuComponent, canActivate: [GmsAuthGuard], data: { breadcrumb: { skip: true } },
  children: [
    { path: '', redirectTo: 'gamemanagement', pathMatch: 'full' },
    { path: 'gamemanagement', data: { breadcrumb: { label: 'Game Management', skip: true } }, loadChildren: () => import('../modules/games-management/games-management.module').then(m => m.GamesManagementModule) },
    { path: 'chatmanagement', data: { breadcrumb: { label: 'Chat Management', skip: true } }, loadChildren: () => import('../modules/chat-management/chat-management.module').then(m => m.ChatManagementModule) },
    { path: 'datareports', data: { breadcrumb: { label: 'Data Reports', skip: true } }, loadChildren: () => import('../modules/data-reports/data-reports.module').then(m => m.DataReportsModule) },
    { path: 'customerservices', data: { breadcrumb: { label: 'Customer Services', skip: true } }, loadChildren: () => import('../modules/customer-services/customer-services.module').then(m => m.CustomerServicesModule) },
    { path: 'administration', data: { breadcrumb: { label: 'Administration', skip: true } }, loadChildren: () => import('../modules/administration/administration.module').then(m => m.AdministrationModule) },
    {
      path: 'bingolobbymanagement',
      data: { breadcrumb: { label: 'Bingo Lobby Management', skip: true } },
      loadChildren: () => import('../modules/bingo-lobby-management/bingo-lobby-management.module')
        .then(m => m.BingoLobbyManagementModule)
    },
  ]
},
{ path: 'welcome', component: GmsWelcomeComponent, canActivate: [GmsAuthGuard] },
{ path: 'changepassword', component: ChangepasswordComponent },
{
  path: '', redirectTo: '/login', pathMatch: 'full'
},
{ path: '**', component: PageNotFoundComponent }

];
//{ path: '', redirectTo: '/login', pathMatch: 'full' },
@NgModule({
  declarations: [],
  imports: [
    RouterModule.forRoot(gmsRoutes)
  ],
  exports: [RouterModule]
})
export class GmsMainRoutingModule {}
